import React from "react";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import styled from "styled-components";
import "swiper/components/pagination/pagination.min.css";
// import "./styles.css";
import SwiperCore, { Autoplay, Pagination } from "swiper/core";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/swiper.min.css";
import LeftArrow from "../assets/bi_arrow-left.svg";
import data from "../data/rushdata.json";


SwiperCore.use([Autoplay, Pagination]);

const HomeOfferSlider = () => {
  return (
    <Wrapper>
      <Container>
        {/* <div className="homeSlider__wrapper"> */}
        <Row className="homeSlider__wrapper">
          <Col xs={12} lg={6} md={12}>
            <div className="home__slider">
              <Swiper
                autoplay={{
                  delay: 3000,
                  disableOnInteraction: false,
                }}
                pagination={{
                  clickable: true,
                }}
                className="mySwiper"
              >
                {data.homeSlider.map(({ id, image }) => (
                  <SwiperSlide key={id}>
                    <div className="home__slider">
                      <img src={image} alt="home slider" />
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </Col>
          <Col xs={12} lg={6} md={12}>
            <div className="homeSlider__right">
              <h1>We cater to both Businesses & Individuals</h1>
              <p>
                Dispatch packages to your business partners, suppliers,
                distributors, customers or parcels to individuals the most
                hassle-free and reliable way.
              </p>
              <button>
                Get Started
                <img src={LeftArrow} alt="" />
              </button>
            </div>
          </Col>
        </Row>
        {/* </div> */}
      </Container>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  .homeSlider__wrapper {
    margin-top: 123px;
  }
  .homeSlider__right {
    margin-top: 130px;
    margin-left: 70px;
    h1 {
      font-family: Gilroy-Heavy;
      font-size: 36px;
      line-height: 46px;
      width: 472px;
      height: 92px;
      color: #6300ff;
    }
    p {
      font-family: Manrope;
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 28px;
      color: #545777;
      width: 445px;
      height: 82px;
      margin-top: 26px;
    }

    button {
      font-family: Gilroy;
      font-style: normal;
      font-weight: 800;
      font-size: 18px;
      line-height: 22px;
      color: #1292ee;
      width: 150px;
      height: 52px;
      border: none;
      outline: none;
      border-radius: 5px;
      position: relative;
      background: transparent;
      margin-top: 40px;
    }

    button::before {
      content: "";
      width: 50%;
      height: 100%;
      background: rgba(18, 146, 238, 0.1);
      left: 0;
      top: 0;
      position: absolute;
      border-radius: 5px;
      transition: 0.4s all;
    }

    button:hover::before {
      width: 100%;
      border-radius: 5px;
    }
    button img {
      margin-left: 12px;
    }
  }
  .home__slider {
    width: 524px;
    height: 607px;
  }

  .home__slider img {
    width: 100%;
    height: 100%;
  }
  .swiper-container-horizontal
    > .swiper-pagination-bullets
    .swiper-pagination-bullet {
    margin: 0 4px;
    width: 10px;
    height: 5px;
    border-radius: 5px;
  }

  @media screen and (max-width: 440px) {
    .homeSlider__wrapper {
      margin-top: 0;
      flex-direction: column-reverse;
      padding-bottom: 40px;
    }
    .homeSlider__right {
      margin-left: 20px;
      h1 {
        font-family: Gilroy-Heavy;
        font-size: 30px;
        line-height: 46px;
        width: 342px;
        height: 92px;
        color: #6300ff;
      }
      p {
        font-family: Manrope;
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 28px;
        color: #545777;
        width: 358px;
        height: 83px;
        margin-top: 26px;
      }

      button {
        font-family: Gilroy;
        font-style: normal;
        font-weight: 800;
        font-size: 14px;
        line-height: 19px;
        color: #1292ee;
        width: 142px;
        height: 42px;
        border: none;
        outline: none;
        border-radius: 5px;
        position: relative;
        background: transparent;
        margin-top: 40px;
      }

      button::before {
        content: "";
        width: 50%;
        height: 100%;
        background: rgba(18, 146, 238, 0.1);
        left: 0;
        top: 0;
        position: absolute;
        border-radius: 5px;
        transition: 0.4s all;
      }

      button:hover::before {
        width: 100%;
        border-radius: 5px;
      }
      button img {
        margin-left: 12px;
      }
    }
    .home__slider {
      width: 100%;
      height: 440px;
      margin-top: 20px;
    }

    .home__slider img {
      width: 100%;
      height: 100%;
    }
    .swiper-container-horizontal
      > .swiper-pagination-bullets
      .swiper-pagination-bullet {
      margin: -12px 4px;
      width: 10px;
      height: 5px;
      border-radius: 5px;
    }
  }

  @media screen and (max-width: 414px) {
    .homeSlider__wrapper {
      margin-top: 0;
      flex-direction: column-reverse;
      padding-bottom: 40px;
    }
    .homeSlider__right {
      margin-left: 20px;
      h1 {
        font-family: Gilroy-Heavy;
        font-size: 30px;
        line-height: 46px;
        width: 342px;
        height: 92px;
        color: #6300ff;
      }
      p {
        font-family: Manrope;
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 28px;
        color: #545777;
        width: 358px;
        height: 83px;
        margin-top: 26px;
      }

      button {
        font-family: Gilroy;
        font-style: normal;
        font-weight: 800;
        font-size: 14px;
        line-height: 19px;
        color: #1292ee;
        width: 142px;
        height: 42px;
        border: none;
        outline: none;
        border-radius: 5px;
        position: relative;
        background: transparent;
        margin-top: 40px;
      }

      button::before {
        content: "";
        width: 50%;
        height: 100%;
        background: rgba(18, 146, 238, 0.1);
        left: 0;
        top: 0;
        position: absolute;
        border-radius: 5px;
        transition: 0.4s all;
      }

      button:hover::before {
        width: 100%;
        border-radius: 5px;
      }
      button img {
        margin-left: 12px;
      }
    }
    .home__slider {
      width: 365px;
      height: 440px;
      margin-top: 20px;
    }

    .home__slider img {
      width: 100%;
      height: 100%;
    }
    .swiper-container-horizontal
      > .swiper-pagination-bullets
      .swiper-pagination-bullet {
      margin: -12px 4px;
      width: 10px;
      height: 5px;
      border-radius: 5px;
    }
  }
`;

export default HomeOfferSlider;
